import React from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import "./providers/theme";
import QueryProvider from "./providers/QueryProvider";
import { AuthProvider } from "./providers/AuthProvider";
import { PreferencesProvider, usePreferences } from "./providers/PreferencesProvider";
import { NumberFormatProvider, useNumberFormat } from "./providers/NumberFormatProvider";
import AppSidebar, {
  CloseMobileSidebarOnNavigate,
} from "./layout/SideBar";
import AppRoutes from "./routes";
import { Button } from "../shared/ui/button";
import {
  SidebarInset,
  SidebarProvider,
  useSidebar,
} from "../shared/ui/sidebar";

function MobileMenuButton() {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      type="button"
      variant="mobileMenu"
      data-mobile-menu-trigger=""
      onClick={toggleSidebar}
      aria-label="باز کردن منو"
    >
      ☰
    </Button>
  );
}

function AppLayout() {
  const location = useLocation();
  const { numeralSystem } = useNumberFormat();
  const { sidebarOpen, setSidebarOpen } = usePreferences();
  const isLogin = location.pathname === "/login";

  if (isLogin) {
    return (
      <div className="min-h-screen w-full bg-background">
        <div key={numeralSystem}>
          <AppRoutes />
        </div>
      </div>
    );
  }

  return (
    <SidebarProvider
      open={sidebarOpen}
      onOpenChange={setSidebarOpen}
      className="min-h-svh w-full bg-background rtl"
      style={{
        "--sidebar-width": "17.5rem",
        "--sidebar-width-icon": "4.75rem",
      }}
    >
      <CloseMobileSidebarOnNavigate />
      <MobileMenuButton />
      <AppSidebar />
      <SidebarInset
        className={
          location.pathname === "/reports/designer"
            ? "h-svh max-h-svh min-w-0 overflow-hidden bg-background max-lg:pt-mobile-topbar"
            : "min-h-svh min-w-0 bg-background max-lg:pt-mobile-topbar"
        }
      >
        <div
          key={numeralSystem}
          className={
            location.pathname === "/reports/designer"
              ? "h-full min-h-0 overflow-hidden"
              : undefined
          }
        >
          <AppRoutes />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}

export default function App() {
  return (
    <Router>
      <QueryProvider>
        <NumberFormatProvider>
          <AuthProvider>
            <PreferencesProvider>
              <AppLayout />
            </PreferencesProvider>
          </AuthProvider>
        </NumberFormatProvider>
      </QueryProvider>
    </Router>
  );
}
